var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { useTheme } from '../../themes';
import { BuilderTypographyProps } from './modifiers';
import * as S from './styles';
export var Typography = forwardRef(function (props, ref) {
    var theme = useTheme();
    var _a = props.type, type = _a === void 0 ? 'h2' : _a, children = props.children, fontSize = props.fontSize, fontWeight = props.fontWeight, lineHeight = props.lineHeight, color = props.color, _b = props.textAlign, textAlign = _b === void 0 ? 'left' : _b, fontStyle = props.fontStyle, htmlFor = props.htmlFor, fontFamily = props.fontFamily, rest = __rest(props, ["type", "children", "fontSize", "fontWeight", "lineHeight", "color", "textAlign", "fontStyle", "htmlFor", "fontFamily"]);
    var typographyProps = BuilderTypographyProps(type);
    var commonStyles = __assign(__assign({}, typographyProps), { fontSize: "".concat(fontSize ? theme.fontSize[fontSize] : typographyProps.fontSize, "px"), fontWeight: "".concat(fontWeight
            ? theme.brand.fontWeight[fontWeight]
            : typographyProps.fontWeight), lineHeight: "".concat(lineHeight
            ? theme.brand.lineHeight[lineHeight]
            : typographyProps.lineHeight, "px"), color: color, textAlign: textAlign, fontStyle: fontStyle, fontFamily: fontFamily !== null && fontFamily !== void 0 ? fontFamily : theme.brand.fontFamily });
    if (type.includes('h')) {
        return (_jsx(S.Heading, __assign({ "data-testid": "typography-heading", ref: ref, style: __assign({}, commonStyles) }, rest, { children: children })));
    }
    if (type.includes('l')) {
        return (_jsx(S.Label, __assign({ "data-testid": "typography-label", ref: ref, style: __assign({}, commonStyles), htmlFor: htmlFor }, rest, { children: children })));
    }
    return (_jsx(S.Text, __assign({ "data-testid": "typography-paragraph", ref: ref, style: __assign({}, commonStyles) }, rest, { children: children })));
});
